import MainBlock from './MainBlock';

import { useEffect } from 'react';

function SatelliteSchool() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return(
      <>
      <div className='sateliteSchoolMainLayoutBlock'>
        <MainBlock />
      </div>
        
      </>
  )
}

export default SatelliteSchool;